// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"476":"moviePlaceholder","594":"about","636":"landing","805":"releases"}[chunkId] || chunkId) + ".universalHub.js?v=" + {"476":"1dd86c6b36424288efd6","594":"bddcf15131751495ddac","636":"6da78415968d4fbd0865","805":"8dd8eee7b6900bd01950","848":"d517a37c14181098380f","996":"668e4c18fabd6f534140"}[chunkId] + "";
};